import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/i18n";
import { formatApiErrorDetail } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const user = await login(email, password);
      navigate(user.role === "admin" ? "/admin" : "/account");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-16 fade-up">
      <div className="w-full max-w-md bg-white border border-[#EAE6E1] p-10">
        <h1 className="font-serif-display text-4xl text-[#1A1F2C] text-center mb-8">{t("login")}</h1>
        <form onSubmit={submit} data-testid="login-form" className="space-y-5">
          <div>
            <label className="text-xs tracking-luxe uppercase text-[#6B7280] block mb-2">{t("email")}</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email"
              className="w-full bg-[#FAF9F6] border border-[#EAE6E1] px-4 py-3 text-sm focus:outline-none focus:border-[#C5A880]" />
          </div>
          <div>
            <label className="text-xs tracking-luxe uppercase text-[#6B7280] block mb-2">{t("password")}</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password"
              className="w-full bg-[#FAF9F6] border border-[#EAE6E1] px-4 py-3 text-sm focus:outline-none focus:border-[#C5A880]" />
          </div>
          {error && <p data-testid="login-error" className="text-sm text-[#991B1B]">{error}</p>}
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full bg-[#1A1F2C] text-white text-xs tracking-luxe uppercase py-4 hover:bg-[#C5A880] transition-colors duration-300 disabled:opacity-60">
            {loading ? t("processing") : t("login")}
          </button>
        </form>
        <p className="text-sm text-[#6B7280] text-center mt-6">
          {t("no_account")} <Link to="/register" data-testid="go-register" className="text-[#1A1F2C] border-b border-[#1A1F2C]">{t("register")}</Link>
        </p>
      </div>
    </div>
  );
}
